export default __webpack_public_path__ + "static/diptnc_blogs_white_logo-abecdd03d9e6c6bbabb3556a4e431660.svg";